import styles from './style.module.scss';
import { Col, Row, Space, Spin, Table, Typography } from 'antd';
import useInvoicesSalesVillage from '../useInvoicesSalesVillage';
import LineChart from '../../../charts/lineChart';
import BarChangeChart from '../../../charts/barChange';
import moment from 'moment/moment';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const {
    title,
    data,
    columns,
    format,
    loading,
    summary,
    searchParams,
    filters,
  } = useInvoicesSalesVillage(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        {byPeriod && byShoppingCenter && (
          <Spin spinning={loading}>
            <br />
            {!allReports && (
              <Row className={styles.titleSection} justify={'center'}>
                <Col>
                  <Typography.Title level={3}>{title}</Typography.Title>
                </Col>
                <PrintFilterText
                  availableFilters={availableFilters}
                  searchParams={searchParams}
                />
              </Row>
            )}
            {allReports && (
              <Row className={styles.titleSection} justify={'center'}>
                <Col>
                  <Typography.Title level={3}>Sales</Typography.Title>
                </Col>
              </Row>
            )}
            <br />
            <Row>
              <Col span={24}>
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={data.tableData}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  summary={summary}
                />
              </Col>
              <Col span={24}>
                <Row className={'chartColl'}>
                  <Col span={12}>
                    <LineChart
                      data={data.lineChartData}
                      tableData={data.tableData}
                      colors={['#61cdbb', '#f47560']}
                    />
                  </Col>
                </Row>
                <Row
                  style={{
                    marginTop: 50,
                  }}
                >
                  <Col span={12}>
                    <BarChangeChart
                      className={styles.chartColl}
                      keys={['Net Sales LY', 'Net Sales YTD']}
                      data={data}
                      format={format}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default Print;
